module.exports = __webpack_public_path__ + "img/BonnieofInt.2b320520.png";